export default class TimeoutError extends Error {}
